import axios from 'axios'
import {
    AJOUTER_QUESTION,
    LISTE_QUESTION,
    LISTE_QUESTION_ACTIVE,
    MODIFIER_QUESTION,
    MODIFIER_ETAT_QUESTION,
    SUPPRIMER_QUESTION,
    AJOUT_QUESTION_EXERCICE,
    LISTE_QUESTION_ACCEPTATION,
    LISTE_GROUPE_QUESTION,
    LISTE_GROUPE_QUESTION_CRITERE,
    LISTE_TYPE_QUESTION,
    LISTE_AUTRE_QUESTION,
    AJOUTER_TYPE_QUESTION
} from '../../api/apiRoutes'
import {setAuthorizationHeader} from "../../api/config";

export const addQuestion = async (data) => {
    setAuthorizationHeader()
    return axios.post(AJOUTER_QUESTION, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const addTypeQuestion = async (data) => {
    setAuthorizationHeader()
    return axios.post(AJOUTER_TYPE_QUESTION, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const updateQuestion = async ({data, question_id}) => {
    setAuthorizationHeader()
    return axios.put(`${MODIFIER_QUESTION}/${question_id}`, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const getListeQuestion = async () => {
    setAuthorizationHeader()
    return axios.get(`${LISTE_QUESTION}`).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const getListeGroupeQuestion = async () => {
    setAuthorizationHeader()
    return axios.get(LISTE_GROUPE_QUESTION).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const getListeTypeQuestion = async () => {
    setAuthorizationHeader()
    return axios.get(LISTE_TYPE_QUESTION).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const getListeAutreQuestion = async () => {
    setAuthorizationHeader()
    return axios.get(LISTE_AUTRE_QUESTION).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const getListeQuestionActive = async () => {
    setAuthorizationHeader()
    return axios.get(LISTE_QUESTION_ACTIVE).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const getListeQuestionAcceptation = async () => {
    setAuthorizationHeader()
    return axios.get(LISTE_QUESTION_ACCEPTATION).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const deleteQuestion = async (data) => {
    setAuthorizationHeader()
    return axios.post(SUPPRIMER_QUESTION, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}


export const updateEtatQuestion = async (data) => {
    setAuthorizationHeader()
    return axios.post(MODIFIER_ETAT_QUESTION, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const ajouterQuestionExercice = async (data) => {
    setAuthorizationHeader()
    return axios.post(AJOUT_QUESTION_EXERCICE, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}